import * as R from 'ramda';
import {BehaviorSubject} from 'rxjs';
import {tap} from 'rxjs/operators';

import ajax from 'iss/utils/ajax';
import subscribeTo from 'iss/utils/subscriptionUtils';
import * as aad from 'iss/utils/azureAd';

const usernameKey = 'iss-username';
const passwordKey = 'iss-password';
const storage = window.localStorage;

const currentPartySubject = new BehaviorSubject(undefined);
let partyFetchInProgress = false;

export const roles = {
    USER: "USER",
    ADMIN: "ADMIN",
    EXT_USER: "EXT_USER",
    EXT_ADMIN: "EXT_ADMIN",
    EXT_TEMPORARY_USER: "EXT_TEMPORARY_USER",
    SITE_MANAGER: "SITE_MANAGER"
};

export function fetchParty() {
  partyFetchInProgress = true;
  return ajax.getJson("/authenticated-party").pipe(tap(
    (party) => {
      currentPartySubject.next(party);
      partyFetchInProgress = false;
    },
    () => {
      partyFetchInProgress = false;
      logout();
    }
  ));
}

export function createParty(email) {
  return ajax.postJson("/party", { email:email, activeAccount:true });
}

export function searchParties(input) {
  return ajax.getJson("/party/search?searchTerm="+input, {showLoadingScreen: false});
}

export function searchPartiesWithRole(input, includeEmailOnlyUsers) {
  let include = includeEmailOnlyUsers === true;
  return ajax.getJson("/party/search?searchTerm="+input+"&includeEmailOnlyUsers="+include, {showLoadingScreen: false});
}

export function hasAdminRole() {
  const party = getCurrentParty();
  return party ? R.includes(roles.ADMIN,party.roles) : false;
}

export function hasExtAdminRole() {
  const party = getCurrentParty();
  return party ? R.includes(roles.EXT_ADMIN,party.roles) : false;
}

export function isCompanyEmployee() {
  const party = getCurrentParty();
  return party ? !R.includes(roles.EXT_USER,party.roles) : false;
}

export function login(username, password) {
  ajax.setAuthenticationDetails(username, password);
  return fetchParty().pipe(tap(() => {
    storage.setItem(usernameKey, username);
    storage.setItem(passwordKey, password);
  }));
}

export async function logout() {
  ajax.clearAuthenticationDetails();
  storage.removeItem(usernameKey);
  storage.removeItem(passwordKey);

  if (aad.isSignedIn()) {
    aad.signOut();
    // Don't wait for the promise returned by signOut() to complete because otherwise the redirect
    // would only happen once user has closed the signout-popup (seeing the current view in
    // the background behind the "you are now signed out" popup looks a bit strange).
  }

  currentPartySubject.next(null);
}

export function isPartyFetchInProgress() {
  return partyFetchInProgress;
}

export function getCurrentParty() {
  return currentPartySubject.getValue();
}

export const currentParty = currentPartySubject.asObservable();
export const subscribeToCurrentParty = subscribeTo(currentParty, "party");

if (storage.getItem(usernameKey)) {
  ajax.setAuthenticationDetails(storage.getItem(usernameKey), storage.getItem(passwordKey));
}

if (ajax.hasAuthenticationDetails() || aad.isSignedIn()) {
  fetchParty().subscribe();
} else {
  currentPartySubject.next(null);
}



// WEBPACK FOOTER //
// ./modules/issFrontend/service/PartyService.js